import { useEffect, useRef } from 'react';
import { Box, Button, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { FormattedMessage } from 'react-intl';
import { useUserDataQuery, useMarkNewsSeenMutation } from '@shared/queries';
import { ImperativeDialog } from '@shared/components/dialogs/imperative-dialog';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { useIntlTranslations } from '@libs/intl/intl.hooks';

const NewsDialog = () => {
  const dialogRef = useRef<ImperativeFormDialogRefType | null>(null);
  const { data: userData } = useUserDataQuery();
  const { mutate: markSeenMutation } = useMarkNewsSeenMutation();
  const { t } = useIntlTranslations();

  useEffect(() => {
    if (userData && userData.hasSeenNews === false) {
      dialogRef.current?.open();
    }
  }, [userData]);

  return (
    <>
      <Button
        onClick={() => dialogRef.current?.open()}
        variant="contained"
        sx={{
          backgroundColor: '#c0db13',
          color: 'rgb(103, 119, 0)',
          '&:hover': {
            backgroundColor: 'rgb(255, 255, 255)',
            '& .MuiSvgIcon-root': { color: '#c0db13 !important' },
            color: '#13dbbdff',
          },
        }}
      >
        <FormattedMessage id="topBar.news" defaultMessage="Novinky" />
      </Button>

      <ImperativeDialog
        ref={dialogRef}
        title={t('newsDialog.title')}
        hideDefaultActions
        actions={
          <Button
            variant="contained"
            onClick={() => {
              markSeenMutation();
              dialogRef.current?.close();
            }}
          >
            {t('news.consent')}
          </Button>
        }
      >
        {/* <YoutubeEmbed
          videoUrl="https://www.youtube.com/shorts/2-yp-ScUIsY"
          title="Nejnovější novinky"
        /> */}

        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            <FormattedMessage id="news.whatsNew" defaultMessage="Co je nového?" />
          </Typography>
          <List dense disablePadding>
            {['news.feature.SMS', 'news.feature.aiStock', 'news.feature.EET'].map(id => (
              <ListItem key={id} disableGutters sx={{ py: 0.25 }}>
                <ListItemIcon sx={{ minWidth: 28 }}>
                  <CheckCircleOutlineIcon fontSize="small" color="success" />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: 'body2' }} primary={t(id)} />
              </ListItem>
            ))}
          </List>
        </Box>

        <Button
          variant="outlined"
          size="small"
          href="https://www.youtube.com/shorts/2-yp-ScUIsY"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ mt: 1 }}
        >
          <FormattedMessage id="news.previousVideo" defaultMessage="Předchozí novinky (video)" />
        </Button>
      </ImperativeDialog>
    </>
  );
};

export default NewsDialog;
